export default "__VITE_ASSET__mcHt8Aw7__"